import { defineStore, acceptHMRUpdate } from 'pinia'

export interface EditPaymentData {
  // Pre-filled values when opening the payment form for editing.

  personId: string | null
  // Person linked to the payment.

  personName: string | null
  // Person display name for the search widget.

  amount: number
  // Amount in major currency units.

  date: string
  // ISO 8601 datetime string.

  link: string | null
  // Optional external URL.

  transactionId: string | null
  // Bank/transaction id.

  text: string | null
  // Raw payment message text.

  billId: number | null
  // Linked bill id; null when unlinked.

  paymentStatus: string
  // Current payment status string.

  subscriptionTypeId: string | null
  // Subscription plan linked to the payment; null when none.
}

export const useAddPaymentFormStore = defineStore('addPaymentForm', {
  state: () => ({
    isOpen: false,
    editId: null as string | null,
    editData: null as EditPaymentData | null,
  }),
  actions: {
    open(): void {
      this.isOpen = true
      this.editId = null
      this.editData = null
    },
    openForEdit(id: string, data: EditPaymentData): void {
      this.isOpen = true
      this.editId = id
      this.editData = data
    },
    close(): void {
      this.isOpen = false
      this.editId = null
      this.editData = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAddPaymentFormStore, import.meta.hot))
}
